import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }, { screen }) => ({
  container: {
    paddingHorizontal: spacing(6),
    paddingVertical: spacing(32),
    alignItems: "center",
    maxWidth: spacing(224),
    marginHorizontal: "auto",
    justifyContent: {
      md: "center",
    },
  },
  step: {
    alignItems: "center",
    gap: spacing(4),
  },
  subtitle: {
    marginBottom: spacing(8),
  },
  field: {
    gap: spacing(2),
  },
  input: {
    width: "100%",
    maxWidth: screen.width * 0.8,
  },
  tintPicker: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing(4),
  },
  buttons: {
    marginTop: spacing(4),
    flexDirection: "column",
    alignItems: "center",
    gap: spacing(4),
  },
}));

export default stylesheet;
